module.exports = __webpack_public_path__ + "img/linux.30343cf6.png";